import axios from "axios";
import { computed, ref } from "vue";
import { APIS_PREDICT, TIMEOUTTIME } from "@/constants/apis";
import { showConsoleError } from "@/functions/errors";
import {
  STRING_GENERAL,
  LABELS,
  TOKEN,
  NAME_PROJECT,
} from "@/constants/labels";
import store from "@/store";
import { getArrayOrSingle } from "@/functions/project";
import {
  EQUIPOS,
  PARAMETROS,
  PARAMETROS_PREDICT,
} from "@/interfaces/SmartLink/Equipos";
import {
  OBJSNR,
  PREDICT_PRED_SNR,
  PREDICT_REAL_SNR,
  PREDICT_TABLE_SNR_ALL,
  SNR_PREDICT_GRAPH,
  SNR_PREDICT_TABLE,
} from "@/interfaces/SmartLink/IA";
const projectName = computed(() => store.state.projectName);

export async function getAllPredictionRXTXData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getAllPredRXData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalObj.value = finalData;
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

// keyof API_PREDICT
// Faltan los Parametros
// ****** CAMBIAR LA API *******
export async function getPredictionRXTXByIP(
  type: string,
  params: PARAMETROS_PREDICT,
) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  const FINAL_API =
    type === STRING_GENERAL.predictall
      ? APIS_PREDICT.value.getPredTabData
      : type === STRING_GENERAL.predictreal
        ? APIS_PREDICT.value.getRealDataByIP
        : APIS_PREDICT.value.getPredDataByIP;

  await axios
    .get(FINAL_API, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<number[][] | EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        if (type === STRING_GENERAL.predictall) {
          finalObj.value = finalData;
        } else {
          finalData.forEach((item: EQUIPOS) => {
            const itemTime = item.fecha ? new Date(item.fecha) : new Date();
            const milliseconds = itemTime.getTime();

            // Para los valores REALES
            if (
              type === STRING_GENERAL.predictreal &&
              typeof item.kpi === "string"
            ) {
              if (projectName.value === NAME_PROJECT.demo) {
                const values = parseFloat(item.kpi ?? "0");
                finalObj.value.push([milliseconds, values]);
              } else if (
                projectName.value === NAME_PROJECT.cananea ||
                projectName.value === NAME_PROJECT.nacozari
              ) {
                const prevValue: any = item.kpi ?? { 'H': 0, 'V': 0, 'PER': 0 };

                // Como trae valores simples o en un array, primero se valida
                // Si existe y si es un objeto (un array), se captura el primer valor del array,
                // Caso contrario se coloca el valor único que tiene
                const RADIOrx =
                  (typeof prevValue["H"]).toUpperCase() == "OBJECT" &&
                    prevValue["H"] !== null
                    ? prevValue["H"][1]
                    : prevValue["H"];

                const values = RADIOrx;
                finalObj.value.push([milliseconds, values]);
              } else {
                // Convierte a JSON la variable "kpi"
                // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
                const prevValue: any = item.kpi ?? { 'tx': 0, 'rx': 0 };

                // Como trae valores simples o en un array, primero se valida
                // Si existe y si es un objeto (un array), se captura el primer valor del array,
                // Caso contrario se coloca el valor único que tiene
                const RADIOrx =
                  (typeof prevValue["rx"]).toUpperCase() == "OBJECT" &&
                    prevValue["rx"] !== null
                    ? parseFloat(prevValue["rx"][0])
                    : parseFloat(prevValue["rx"]);

                const values = RADIOrx;
                finalObj.value.push([milliseconds, values]);
              }
            }

            // Para los valores de predict
            else {
              const values = typeof item.kpi === "number" ? item.kpi : 0;
              finalObj.value.push([milliseconds, values]);
            }
          });
        }
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllPredictionSNRData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getAllSNRData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalObj.value = finalData;
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllPredictionPREDSNRByIP(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getPredSNRByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: SNR_PREDICT_GRAPH[] = response.data;
      const finalObj = ref<PREDICT_PRED_SNR>({
        predVER: [],
        predHOR: [],
      });
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: SNR_PREDICT_GRAPH) => {
          const itemTime = new Date(item.fecha ?? "");
          const milliseconds = itemTime.getTime();
          const values = item.snr;
          if (item.causa) {
            if (item.causa.toUpperCase() === LABELS.predsnrh) {
              finalObj.value.predHOR.push([milliseconds, values]);
            }
            if (item.causa.toUpperCase() === LABELS.predsnrv) {
              finalObj.value.predVER.push([milliseconds, values]);
            }
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllPredictionREALSNRByIP(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getRealSNRByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<PREDICT_REAL_SNR>({
        realVER: [],
        realHOR: [],
      });
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          const itemTime = new Date(item.fecha ?? "");
          const milliseconds = itemTime.getTime();

          if (
            projectName.value === NAME_PROJECT.cananea ||
            projectName.value === NAME_PROJECT.demo ||
            projectName.value === NAME_PROJECT.nacozari
          ) {
            const allSNR: any = item.snr ?? { 'H': 0, 'V': 0, 'PER': 0 };

            const SNRV = getArrayOrSingle(allSNR["V"], 3);
            const SNRH = getArrayOrSingle(allSNR["H"], 3);

            finalObj.value.realVER.push([milliseconds, SNRV]);
            finalObj.value.realHOR.push([milliseconds, SNRH]);
          } else {
            const allSNR: any = item.snr ?? { "V": 0, "H": 0 };

            const SNRV = getArrayOrSingle(allSNR["V"], 0);
            const SNRH = getArrayOrSingle(allSNR["H"], 0);

            finalObj.value.realVER.push([milliseconds, SNRV]);
            finalObj.value.realHOR.push([milliseconds, SNRH]);
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllPredictionTABSNRByIP(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_PREDICT.value.getTabSNRByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: SNR_PREDICT_TABLE[] = response.data;
      const finalObj = ref<PREDICT_TABLE_SNR_ALL>({
        tabVER: [],
        tabHOR: [],
      });
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: SNR_PREDICT_TABLE) => {
          const objSNR: OBJSNR = {
            fecha: item.fecha,
            ip: item.ip,
            status: item.status,
            causa: item.causa,
            value: item.snr,
          };

          if (item.causa.toUpperCase() === "PREDICT SNR V") {
            finalObj.value.tabVER.push(objSNR);
          }
          if (item.causa.toUpperCase() === "PREDICT SNR H") {
            finalObj.value.tabHOR.push(objSNR);
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}
